import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const fetchJobPostings = async () => {
  try {
    const response = await axiosInstance.get(API.hiringJobPosting.getAllPostings);
    const postings = Array.isArray(response.data) ? response.data : [];
    const filtered = postings.filter((posting) => posting.status === 0 || posting.status === 3);
    return filtered;
  } catch (error) {
    console.error("Error fetching employee numbers:", error);
    return [];
  }
};

export const fetchEmployeeNumbers = async () => {
  try {
    const response = await axiosInstance.get(API.hiringJobPosting.getAllPostings);
    const postings = Array.isArray(response.data) ? response.data : [];
    const filtered = postings.filter((posting) => posting.status === 0 || posting.status === 3);
    return filtered;
  } catch (error) {
    console.error("Error fetching employee numbers:", error);
    return [];
  }
};

export const fetchFeedbackEmployees = async (jobPostingId) => {
  try {
    const response = await axiosInstance.get(API.hiringJobApplicant.getListByPosting(jobPostingId));
    const applicants = Array.isArray(response.data?.applicants) ? response.data?.applicants : [];
    return applicants;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    return null;
  }
};

export const fetchEmployeeData = async (jobApplicantId) => {
  try {
    const response = await axiosInstance.get(API.hiringJobApplicant.getById(jobApplicantId));
    return response.data || null;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    return null;
  }
};

export const submitEmployeeDocuments = async (formData) => {
  try {
    const response = await axiosInstance.post(API.hiringContracts.sendContracts, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      // Increase timeout to 5 minutes (300,000ms)
      // Or set to 0 to wait indefinitely
      timeout: 300000,
    });

    return response.data;
  } catch (error) {
    console.error("Full Error Details:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers,
    });

    // Specific check for timeout to give a better error message
    if (error.code === "ECONNABORTED") {
      throw "Upload timed out. The files are too large or your connection is slow.";
    }

    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.details ||
      error.message ||
      "Server error. Please contact support.";
    throw errorMsg;
  }
};
